const selectors = {
  productContainer: document.querySelector('.product-details-wrapper'),
  productMedia: document.querySelector('[data-productMedia]')
};

const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
window.productMedia = mediaJSON;
class TemplateProductJS {
  constructor() {
    // Custom code for product page goes here
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();

const box = document.querySelector('.product-add-cart');
var stickyBtn = document.querySelector('[data-stickyBtn]');
document.addEventListener('scroll', function () {
  if(isInViewport(box)){
       if(stickyBtn.classList.contains('d-block')){
          stickyBtn.classList.remove('d-block');
      }
      stickyBtn.classList.add('d-none');
  } else{
     if(stickyBtn.classList.contains('d-none')){
          stickyBtn.classList.remove('d-none');
      }
      stickyBtn.classList.add('d-block');
      if (stickyBtn) {
        document.body.style.paddingBottom = `${stickyBtn.offsetHeight}px`;
      }
  }
}, {
  passive: true
});
function isInViewport(el) {
const rect = el.getBoundingClientRect();
return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
);
}

function adjustTitleFontSize() {
  const titleElement = document.querySelector('[data-product-page-title]') ?? null;
  if (!titleElement) return;

  let parentWidth = titleElement.parentElement.clientWidth; // Get available width
  let textWidth = titleElement.scrollWidth; // Get actual text width
  let fontSize = parseFloat(window.getComputedStyle(titleElement).fontSize); // Get current font size

  // Reduce font size until text fits within one line
  while (textWidth > parentWidth && fontSize > 10) { 
      fontSize -= 1; // Decrease font size step by step
      titleElement.style.fontSize = fontSize + "px";
      textWidth = titleElement.scrollWidth; // Update width after resizing
  }
}

// Run on page load
window.addEventListener('load', adjustTitleFontSize);

// Run on window resize for responsiveness
window.addEventListener('resize', adjustTitleFontSize);
